import { render, staticRenderFns } from "./ImportPageItem.vue?vue&type=template&id=681a66a7"
import script from "./ImportPageItem.vue?vue&type=script&lang=ts"
export * from "./ImportPageItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports